import(/* webpackMode: "eager" */ "/Users/christinadastolfo/Documents/Optera/oc-nextjs-serverless/app/error.tsx");
